module.exports = __webpack_public_path__ + "static/img/qichetu.5320110.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productlist/qichetu.jpg
// module id = SWr+
// module chunks = 1